<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="MBA"
                   :links="[{title:'Home', url:'/'},{title:'Students Club'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="10"></sidebar>
        </section>
        <section class="content">
            <div class="heading-black1">Students Club</div>
            <tab-view>
              <tab-panel>
                <template #header>
                  <i class="pi pi-home mr-1"></i>
                  <span>About</span>
                </template>
                <div>
                  <h4 class="text-3xl text-center">ITIANS - STUDENT CLUB</h4>
                  <p class="text-justify text-gray-600">ITIANS club formed in the year 2016 by students of the
                    Department
                    of Information Technology on the Engineer’s Day occasion under the guidance of Prof Rokade P P head
                    of
                    Information Technology Department. This club is basically formed to enhance skill level of student
                    other than regular curriculum and give benefits to student who wants to do more activity with their
                    talent in any field. Club Consist of President and vice president along with two members from every
                    division.. Members are selected in the presence of Staff club Coordinator ,other staff , all
                    students
                    from S.E, T.E, B.E participate. ITIANS club play a pivotal role in the development of students as
                    engineers by various out-of-curriculum and extracurricular activities. Apart from the technical
                    aspects, it also undertakes the responsibility of proper nurturing of students by organizing some
                    social and awareness events as a part of Society’s development. Different Visit to Old Age Home
                    Every
                    semester ITIANS go visit old friends and spend some quality time with them. Visit to Deaf and Mute
                    School Regular visits / trips are made to the institution of children who cannot speak or
                    listen. </p>
                </div>
                <div class="mt-3">
                  <h4 class="text-3xl text-center">Red Ribbon Club</h4>
                  <p class="text-justify text-gray-600">The RRC youth of SND College of Engineering & Research Center
                    Yeola is encouraged to learn about safe and healthy lifestyles. The RRC promotes access to
                    information on healthy life and voluntary blood donation. They create and provide opportunity to the
                    zeal of volunteerism among youth to contribute towards the control and prevention of HIV&AIDS. The
                    Red Ribbon Club is a voluntary on-campus intervention program for students. The programme organized
                    by RRC addresses the knowledge, attitude and behavior of the youths in the interrelated areas of
                    Voluntary Blood Donation, HIV & AIDS, as demanded by their age, environment, and life style.</p>
                </div>

              </tab-panel>
              <tab-panel>
                <template #header>
                  <i class="pi pi-id-card mr-1"></i>
                  <span>Committee</span>
                </template>
              </tab-panel>
              <tab-panel>
                <template #header>
                  <i class="pi pi-bars mr-1"></i>
                  <span>Activities</span>
                </template>
              </tab-panel>
              <tab-panel>
                <template #header>
                  <i class="pi pi-align-justify mr-1"></i>
                  <span>Activity Plan</span>
                </template>
              </tab-panel>
            </tab-view>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/mba/Sidebar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Students_Club",
  components: {
    NavbarComponent,KeyRecruiters,
    PageHeader,
    Sidebar,
    FooterComponent,
    TabView,
    TabPanel,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      constitutions: [
        'President 01 (preferably from B.E.)',
        'Vice President 01 (preferably from T.E.)',
        'Secretary (preferably from B.E.)',
        'Treasurer 01 (preferably from S.E.)',
        'Executive Member 6 (From any Class)',
        'All students are member of Association'],
      dirName: 'civil',
      members: [
        {
          sr: '1',
          name: 'TEKALE TUSHAR BALASAHEB',
          designation: 'President',
          photo: 'takale_tushar'
        },
        {
          sr: '2',
          name: 'SARODE PUJA SUNIL',
          designation: 'Vice President',
          photo: 'sarode_pooja'
        },
        {
          sr: '3',
          name: 'MOKATE PRATHMESH RAJENDRA',
          designation: 'Secretary',
          photo: 'mokate_prathmesh'
        },
        {
          sr: '4',
          name: 'WAKTE GOKUL JAYWANT',
          designation: 'Member',
          photo: 'wakte_gokul'
        },
        {
          sr: '5',
          name: 'GAIKWAD VAIBHAV KAILAS',
          designation: 'Member',
          photo: 'gaikwad_vaibhav'
        },
        {
          sr: '6',
          name: 'MADHVAI TEJAS SANJAY',
          designation: 'Member',
          photo: 'madhvai_tejas'
        },
        {
          sr: '7',
          name: 'JAGTAP PRAJAKTA ASHOK',
          designation: 'Member',
          photo: 'jagtap_prajkta'
        },
        {
          sr: '8',
          name: 'TALOLE AJINKYA SHIVAJI',
          designation: 'Member',
          photo: 'talole_ajinkya'
        },
        {
          sr: '9',
          name: 'DANGE AMIT UTTAM',
          designation: 'Member',
          photo: 'dange_amit'
        },
        {
          sr: '10',
          name: 'DANEJ PANKAJ RAVINDRA',
          designation: 'Treasurer',
          photo: 'danej_pankaj'
        }
      ],
      activities: [
        {
          month: '1<sup>st</sup> Month'
        },
        {
          sr: '1',
          activity: 'Formation of  Committee',
          tentative: 'First week'
        },
        {
          sr: '2',
          activity: 'Celebration of Teacher’s Day',
          tentative: 'First week'
        },
        {
          sr: '3',
          activity: 'Celebration of Engineer’s Day',
          tentative: 'Third Week'
        },
        {
          month: '2nd Month'
        },
        {
          sr: '4',
          activity: 'Celebration of Gandhi Jayanti',
          tentative: 'First week'
        },
        {
          sr: '5',
          activity: 'Expert talk on New Trends in Civil Engineering',
          tentative: 'Second Week'
        },
        {
          sr: '6',
          activity: 'Student Development Program for TE (Aptitude Test)',
          tentative: 'Second Week'
        },
        {
          sr: '7',
          activity: 'Student Development Program for TE (Aptitude Test)',
          tentative: 'Third Week'
        },
        {
          sr: '8',
          activity: 'Expert talk on Sustainability in Civil Engineering',
          tentative: 'Third Week'
        },
        {
          sr: '9',
          activity: 'Expert Talk ',
          tentative: 'Fourth Week'
        },
        {
          sr: '10',
          activity: 'Demo on AutoCad Software',
          tentative: 'Fourth Week'
        },
        {
          month: '3rd Month'
        },
        {
          sr: '11',
          activity: 'Expert talk ',
          tentative: 'First week'
        },
        {
          sr: '12',
          activity: 'Expert talk ',
          tentative: 'Second Week'
        },
        {
          sr: '13',
          activity: 'Demo of Primavera Software',
          tentative: 'Third Week'
        },
        {
          sr: '14',
          activity: 'Demo of MSP Software',
          tentative: 'Third Week'
        },
        {
          sr: '15',
          activity: 'Guest Lecture on Albedo Foundation',
          tentative: 'Fourth Week'
        },
        {
          sr: '16',
          activity: 'Expert talk ',
          tentative: 'Fourth Week'
        },
        {
          month: '4th Month'
        },
        {
          sr: '17',
          activity: 'Student Development Program for BE (Aptitude Test)',
          tentative: 'First week'
        },
        {
          sr: '18',
          activity: 'Expert Talk on SAP in construction industry',
          tentative: 'Second Week'
        },
        {
          sr: '19',
          activity: 'Student Development program for BE (GD and PI)',
          tentative: 'Second Week'
        },
        {
          sr: '20',
          activity: 'Expert Talk on Competitive Exam',
          tentative: 'Third Week'
        },
        {
          sr: '21',
          activity: 'End of Semester',
          tentative: 'Fourth Week'
        },
      ],
      civilactivities: [
        {
          name: "A guest lecture was conducted on Construction of Nuclear Power plant",
          date: "",
          details: "A guest lecture was conducted on Construction of Nuclear Power plant by Dr Chandrashekra .He taught the construction phases of a new nuclear power plant and vital safe operation of the facility through its design life.",
          images: [
            {
              "itemImageSrc": "/static/images/civil/studentClub/activity/nuclear_power.jpg",
              "thumbnailImageSrc": "/static/images/civil/studentClub/activity/nuclear_power.jpg",
              "alt": "Construction of Nuclear Power plant",
              "title": "Guest Lecture"
            },

          ]
        },
        {
          name: "Expert lecture on Dams and Hydraulic Structure",
          date: "05 Jan 2017",
          details: "Expert lecture on Dams and Hydraulic Structure  was delivered by Dr.C.L.Jejurkar on 05/01/2017. He explained major hydraulic aspects of dam engineering considering recent developments in research and construction, namely overflow, conveyance and dissipations structures of spillways, river diversion facilities during construction, bottom and low-level outlets as well as intake structures. Furthermore, the he covered reservoir sedimentation, impulse waves and dam break waves, which are relevant topics in view of sustainable and safe operation of reservoirs.",
          images: [
            {
              "itemImageSrc": "/static/images/civil/studentClub/activity/hydralic_lecture.jpg",
              "thumbnailImageSrc": "/static/images/civil/studentClub/activity/hydralic_lecture.jpg",
              "alt": "Expert lecture on Dams and Hydraulic Structure",
              "title": "Guest Lecture"
            },

          ]
        },
        {
          name: "A guest lecture on How to crack MPSC Engineering Service Exam",
          date: "08 Sep 2016",
          details: "A guest lecture on “How to crack MPSC Engineering Service Exam” was held on 08 September 2016. The guest lecture was organized by CESA to provide the students with brief introduction about the syllabus and exam pattern of MPSC Engineering Service exam. The lecture was delivered by Er.Uddhav Murkute who is working as Executive Engineer in Water Resource department Government of Maharashtra.",
          images: [
            {
              "itemImageSrc": "/static/images/civil/studentClub/activity/mpsc_guest_lecture.jpg",
              "thumbnailImageSrc": "/static/images/civil/studentClub/activity/mpsc_guest_lecture.jpg",
              "alt": "A guest lecture on “How to crack MPSC Engineering Service Exam",
              "title": "Guest Lecture"
            },

          ]
        },]
    }
  }
}
</script>
<style lang="scss" scoped/>
